<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- タイトル -->
    <div class="p-d-flex p-jc-center title">
      <div>
        <label>地方創生SDGs官民連携プラットフォーム</label><br />
        <label class="p-d-flex p-jc-center title-name">事例紹介記事</label>
      </div>
    </div>

    <div class="p-d-flex p-jc-center information-title">{{ detailArticle?.head }}</div>

    <!-- 編集ボタンエリア -->
    <div class="p-d-flex p-jc-center button-area">
      <!-- 編集ボタン -->
      <button
        pButton
        type="button"
        label="編集する"
        icon="pi pi-pencil"
        class="button1"
        (click)="moveJ203()"
      ></button>
    </div>

    <!-- 記事詳細 -->
    <p-table [value]="[{}]" styleClass="information-Form">
      <ng-template pTemplate="body">
<!--        <div class="p-d-flex p-jc-center img-contents">-->
<!--          <div-->
<!--            class="view-size"-->
<!--            *ngIf="detailArticle?.article_image.file_path.length != 0"-->
<!--          >-->
<!--            <img-->
<!--              [src]="detailArticle?.article_image.file_path"-->
<!--              alt="image"-->
<!--              id="article_image"-->
<!--              onerror="this.src= 'https://naikakufu-stg-file.s3.ap-northeast-1.amazonaws.com/image_proseccing.png'"-->
<!--              [ngStyle]="setImageSize('article_image')"-->
<!--            />-->
<!--          </div>-->
<!--        </div>-->
        <!-- タイトル -->
        <tr>
          <td class="item-name">タイトル</td>
          <td class="item-information">
            {{ detailArticle?.title }}
          </td>
        </tr>
        <!-- 概要 -->
        <tr>
          <td class="item-name">概要</td>
          <td class="item-information">
            {{ detailArticle?.description }}
          </td>
        </tr>
        <!-- サムネイル -->
        <tr>
          <td class="item-name">サムネイル</td>
          <td class="item-information img-contents">
            <div
              class="view-size"
              *ngIf="detailArticle?.article_image.file_path.length != 0"
            >
              <img
                [src]="detailArticle?.article_image.file_path"
                alt="image"
                id="article_image"
                onerror="this.src= 'https://naikakufu-stg-file.s3.ap-northeast-1.amazonaws.com/image_proseccing.png'"
                [ngStyle]="setImageSize('article_image')"
              />
            </div>
          </td>
        </tr>
        <!-- 記事URL -->
        <tr>
          <td class="item-name">記事URL</td>
          <td class="item-information">
            <a [href]="detailArticle?.article_url" target="_blank">
              {{ detailArticle?.article_url }}
            </a>
          </td>
        </tr>
        <!-- 作成日 -->
        <tr>
          <td class="item-name">作成日</td>
          <td class="item-information">
            {{ detailArticle?.create_datetime }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
